export const PRECISION_CRYPTO_APPROX = 8;
export const PRECISION_USD = 2;
export const DEFAULT_PRECISION = 4;
export const DEFAULT_PRICE_PRECISION = 0;
export const DECIMAL_MARKER = '.';
export const PRECISION_CRYPTO = 18;
